// const Vue = require('vue');

function prevent(e) {
    if (e.preventDefault != null) {
        e.preventDefault();
    } else {
        e.returnValue = false;
    }
}

function selectionStart(input) {
    if (!input) {
        return -1;
    }
    if (input.selectionStart != null) {
        return input.selectionStart;
    }
    // IE
    try {
        const range = document.selection.createRange();
        range.moveStart('character', -input.value.length);
        return range.text.length;
    } catch (e) {
        return 0;
    }
}

// eslint-disable-next-line
function onNumberKeydown(flag) {
    // eslint-disable-next-line func-names
    return function (e) {
        // eslint-disable-next-line no-console
        // console.log(e);
        if (e.keyCode === 8 || e.keyCode === 9) {
            // Backspace
            // Tab
        } else if (e.keyCode === 46) {
            // Delete
        } else if (e.keyCode >= 35 && e.keyCode <= 40) {
            // End, Home
            // Arrow Left, Up, Right, Down
        } else if (e.keyCode === 65 && e.ctrlKey) {
            // Ctrl+A
        } else if ((flag === 'float') && (e.keyCode === 110 || e.keyCode === 190)) {
            // . || Decimal
            if (this.value.indexOf('.') >= 0) {
                prevent(e);
            }
        } else if (e.keyCode === 173 || e.keyCode === 189 || e.keyCode === 109) {
            // - || NumpadSubtract
            if (flag === 'noneg') {
                prevent(e);
            } else if (this.value.indexOf('-') >= 0) {
                prevent(e);
            } else if (selectionStart(e.target) !== 0) {
                prevent(e);
            }
        } else if ((e.keyCode < 48 || e.keyCode > 57) &&
            (e.keyCode < 96 || e.keyCode > 105)) {
            prevent(e);
        } else if (e.shiftKey) {
            prevent(e);
        }
    };
}

module.exports = {
    install(Vue) {
        Vue.directive('fic-number', {
            bind(el, binding) {
                el.addEventListener('keydown', onNumberKeydown(binding.arg));
            },
        });
    },
    options: {
        bind(el, binding) {
            if (binding.value === true) {
                el.addEventListener('keydown', onNumberKeydown(binding.arg));
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/vue-ctrls/directives.js